import MaterialTable from 'material-table'
import React, { useContext, useEffect, useState } from 'react'
import StatusButton from '../StatusButton';
import tableIcons, { options } from 'components/universal/table_attributes'
import SelectedCoreDetails from './SelectedCoreDetails';
import FinanceDetails from './FinanceDetails';
import AddIcon from '@material-ui/icons/AddBox';
import ManageCreateCore from './ManageCreateCore';
import { getColors, getOrganisationId } from 'lib/utils/common_utils';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { useTheme, alpha, Table, Grid } from '@material-ui/core';
import { FlyingSpannerServices } from 'lib/services/api/operaitons/WorkShop/FlyingSpanner/flyingspanner';
import { WorkshopContext } from 'views/Operations/Workshop/WorkshopContext/WorkshopContext';




export default function CoreExchange(props) {
    const { coreId, coreDetails, permission, headerDetails, isInvoiceOpen, writePermission } = props
    const theme = useTheme()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [action, setAction] = useState(null)
    const [totalCredit, setTotalCredit] = useState("0.00")
    const [currentSelection, setCurrentSelection] = useState(null)
    const [defaultCurrency, setDefaultCurrency] = useState({})
    const [lastRow, setLastRow] = useState({})
    const [s_data, setSData] = useState([])
    const [isRefreshTable, setIsRefreshTable] = useState(false)
    const { salesPaidStatus } = useContext(WorkshopContext)
    const isPaid = salesPaidStatus ?? coreDetails?.paid

    const tableOptions = {
        ...options,
        search: false,
        // toolbar: false,
        paging: false,
        showFooter: true
    };

    const getCoreTableDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            core_parent_id: coreId

        }
        setLoading(true)
        try {
            const response = await PartSalesServices.getSubCoreExchangeDetails(params)
            setTotalCredit(+response?.total_credit > 0 ? +response?.total_credit.toFixed(2) : "0.00")
            if (response?.data.length > 0) {
                let modifiedData = response?.data.map((item, index, arr) => ({
                    ...item,
                    highest_row: index === arr.length - 1
                }));
                setData(modifiedData)
                const lastItem = response?.data?.length > 0 && response?.data[response?.data.length - 1];
                if (lastItem) {
                    setLastRow(lastItem)
                }

            } else {
                setData([])
            }

        }
        catch {

        }
        finally {
            setLoading(false)
        }


    }



    useEffect(() => {
        if (coreId) {
            getCoreTableDetails()
        }
    }, [coreId])
    const getCurrency = () => {


        FlyingSpannerServices.fetchCurrency().then((res) => {
            if (res) {
                let value = res?.data.find((item) => item.default_status === true)
                setDefaultCurrency(value)
            }
        })
            .catch((err) => {
                //console.log({ err })
            });

    }
    useEffect(() => {

        getCurrency()
    }, []);


    const columns = [

        {
            title: "Status",
            field: "status",
            headerStyle: {

                textAlign: "left",
                paddingLeft: "15px"
            },
            cellStyle: {

                textAlign: "left",
                paddingLeft: "7px"
            },
            render: (rowData) =>

                <StatusButton
                    status={rowData?.status}
                    rowType={rowData?.type}
                    setAction={setAction}
                    setCurrentSelection={setCurrentSelection}
                    due_date={rowData?.date}
                    rowDetails={rowData}
                    type={"sub"} getDetails={getCoreTableDetails}
                    paid={isPaid}
                    writePermission={writePermission}
                />



        },

        {
            title: "Type",
            field: "type",
            headerStyle: {

                textAlign: "left"
            },
            cellStyle: {

                textAlign: "left"
            }
        },
        {
            title: "Part #",
            field: "part",
            width: "12%",
            headerStyle: {
                width: "12%",
                textAlign: "left"
            },
            cellStyle: {
                width: "12%",
                textAlign: "left"
            },

        },
        {
            title: "Description",
            field: "description",
            width: "20%",
            headerStyle: {
                width: "20%",
                textAlign: "left"
            },
            cellStyle: {
                width: "20%",
                textAlign: "left"
            }

        },
        {
            title: "QTY",
            field: "qyt",
        },
        {
            title: "Core Value",
            field: "core_value",
        }, {
            title: "Shipping",
            field: "shipping",

            render: (rowData) => <>{parseFloat(rowData?.shipping || 0).toFixed(2)}</>
        }, {
            title: "Late Fees",
            field: "late_fee",
        }, {
            title: "Trace Fees",
            field: "trace_fee",
        }, {
            title: "Repair Fees",
            field: "repair_fee",
        },

        {
            title: "Currency",
            field: "currency",
        },
        {
            title: "Credit *",
            field: "credit",
            render: (rowData) => <span style={{ color: +rowData?.credit < 0 ? getColors("red") : getColors("green"), fontWeight: 600 }}>{rowData?.credit}</span>
        },



    ];

    const handleClose = () => {
        setAction(null)
        getCoreTableDetails()
    }

    let currrencyDetails = {
        currency_name: coreDetails?.currency,
        sales_rate: coreDetails?.sales_rate,

        id: coreDetails?.currency_id

    }
    let lateDetails = {

        late_fee_value: coreDetails?.late_fee || headerDetails?.late_fee

    }
    const commonProps = {
        handleClose: handleClose,
        action,
        disabled: false,
        defaultCurrency: defaultCurrency,
        currrencyDetails,
        quotationId: coreDetails?.sales_order_id,
        quotationDetails: lateDetails,
        currentSelection: coreDetails,
        tabName: "core_exchange",
        s_data: s_data,
        setSData: setSData,
        coreId: coreId,
        writePermission,
        permission
    }


    const renderActions = (value) => {

        const page = {
            "create": <ManageCreateCore {...commonProps} />


        }

        return page[value]


    }

    let coreProps = {

        setIsRefreshTable,
        isRefreshTable
    }

    return (
        <>

            <MaterialTable
                style={{ boxShadow: "0px 1px 3px #00000033", paddingBottom: "40px" }}
                icons={tableIcons}
                title={""}
                columns={columns}
                data={data || []}
                isLoading={loading}
                options={{
                    ...tableOptions,
                    rowStyle: rowData =>
                    ({
                        backgroundColor: (currentSelection?.id === rowData.id) ? `${alpha(theme.palette.secondary.main, 0.20)}` : '#FFF',
                        height: "42px"
                    }),

                }}
                actions={data.length > 0 && lastRow?.status === "rejected" && !isPaid
                    && writePermission && [
                        {
                            icon: () => <AddIcon color="secondary" />,
                            tooltip: 'Add',
                            isFreeAction: true,
                            onClick: (event) => setAction("create")
                        }
                    ]}

                onRowClick={(event, rowData) => {
                    setCurrentSelection(rowData)
                }}
            />

            <Grid container style={{
                position: "relative",
                marginTop: "-28px",
                paddingLeft: "23px",
                paddingRight: "12px",
                marginBottom: "30px"
            }} >
                <Grid item xs={7}>Total</Grid>
                <Grid item xs={3} style={{ textAlign: "right", fontSize: "12px", fontStyle: "italic" }}>Note - Total will return 0.00 if less than zero</Grid>
                <Grid item xs={2} style={{ textAlign: "right", fontWeight: 600 }}>{totalCredit}</Grid>


            </Grid>

            <SelectedCoreDetails
                tab={"core"}
                currentSelection={currentSelection}
                coreDetails={coreDetails}
                getCoreTableDetails={getCoreTableDetails}
                writePermission={writePermission}
                coreLoading={loading}
                permission={permission}
                {...coreProps} />
            <FinanceDetails
                coreId={headerDetails?.core_ex_id}
                coreDetails={coreDetails}
                getCoreTableDetails={getCoreTableDetails}
                permission={permission}
                isInvoiceOpen={isInvoiceOpen}
                {...coreProps} />

            {action && renderActions(action)}





        </>
    )
}
